'use client';
import LinkLikeButton from '@/src/features/shared/link-like-button';
import ImageWithFallback from '@/src/features/ui/image/image-with-fallback';
import Modal from '@/src/features/ui/modal/modal';
import { ResponseStoreFrontSmeLoanDetail } from '@/src/interfaces/data-contracts';
import { Pages } from '@/src/interfaces/pages-route';

type SpecialZoneProps = {
  data: ResponseStoreFrontSmeLoanDetail;
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  smeRedirectProductList: Pages.SmeRedirectproductList.ResponseBody;
};
const SpecialZone: React.FC<SpecialZoneProps> = ({ data, showModal, setShowModal, smeRedirectProductList }) => {
  function handleClose() {
    setShowModal(false);
  }

  return (
    <Modal show={showModal} className="!max-w-[630px]" onClose={handleClose}>
      <div className="flex flex-col p-2 md:p-7">
        <ImageWithFallback
          src={smeRedirectProductList?.bankLogo}
          alt={smeRedirectProductList?.bankName}
          width={150}
          height={72}
          className="mx-auto"
        />
        <div className="mt-4 text-center text-base font-semibold text-black900 md:mt-6 md:text-lg">
          {data.bank?.name} ile anlaşmamız bulunmamaktadır.
        </div>
        {smeRedirectProductList && (
          <div
            className="mt-1 text-center text-sm text-black700 md:mt-4 md:text-base"
            dangerouslySetInnerHTML={{ __html: smeRedirectProductList.redirectText ?? '' }}
          ></div>
        )}
        {data && smeRedirectProductList?.redirectUrl && (
          <LinkLikeButton
            href={smeRedirectProductList.redirectUrl}
            text={smeRedirectProductList.redirectButtonText ?? 'Hemen Başvur'}
            className="mx-auto mt-5 w-[181px] md:mt-8"
          />
        )}
      </div>
    </Modal>
  );
};

export default SpecialZone;
